export default {
    regionalRiskAssessment: {
      eudrDueDiligence: "Diligencia Debida EUDR",
      title: "Evaluación Regional de Riesgos",
      titleTT: "Análisis comparativo de países en la evaluación de riesgo regional de EUDR",
      details: "Detalles",
      detailsTT: "Expanda para ver criterios detallados y referencias relacionadas con la clasificación de alto riesgo, centrándose en la deforestación, los derechos indígenas, la corrupción y los derechos humanos.",
      createNewCountryReport: "Crear Nuevo Informe de País",
      updateCountryReport: "Actualizar Informe de País",
      duplicateCountryReport: "Duplicar Informe de País",
      search: "Buscar",
      country: "País",
      dateCreated: "Fecha de Creación",
      edit: "Editar",
      delete: "Eliminar",
      duplicate: "Duplicar",
      actions: "Acciones",
      submit: "Enviar",
      save: "Guardar",
      cancel: "Cancelar",
      selectCountry: "Seleccionar País",
      riskAssessmentCriteria: "Criterios de Evaluación de Riesgos",
      riskLevel: "Nivel de Riesgo",
      unassigned: "No Asignado",
      standard: "Estándar",
      standardToHigh: "Estándar a Alto",
      high: "Alto",
      reportDetails: "Detalles del Informe",
      select: "Seleccionar",
      requiredFields: "Este campo es obligatorio",
      pleaseFillRequiredFields: "Por favor, complete todos los campos obligatorios",
      createCuccess: "Evaluación regional de riesgos creada con éxito",
      updateSuccess: "Evaluación regional de riesgos actualizada con éxito",
      createError: "Error al crear la evaluación regional de riesgos",
      updateError: "Error al actualizar la evaluación regional de riesgos",
      deleteSuccess: "Evaluación regional de riesgos eliminada con éxito",
      duplicateSuccess: "Evaluación regional de riesgos duplicada con éxito",
      deleteRegionalRisk: "Eliminar Evaluación Regional de Riesgos",
      confirmDelete: "¿Está seguro de que desea eliminar esta evaluación regional de riesgos?",
      confirm: "Confirmar",
      saveSuccess: "Evaluación regional de riesgos guardada con éxito",
      fetchError: "Error al obtener la evaluación regional de riesgos",
      disregard: "Desestimar Segmentos",
      addRegionalRiskAssessment: "Añadir Evaluación de Riesgo Regional",
      summary: "Resumen",
      summaryTT: "Esta sección describe los niveles de riesgo asignados basados en datos y referencias exhaustivos.",
      summaryText: "La evaluación de riesgo del país clasificará el país de la granja según los siguientes niveles de riesgo (Alto, Estándar y Cero/Négligible) basados en referencias verificables, información, documentos y datos. Los resultados diferentes de 'Cero/Négligible' indicarán la necesidad de alguna acción de mitigación de riesgo (AMR) para garantizar un 'Riesgo Cero/Négligible'. La Tabla 1 muestra los resultados generales de la evaluación de riesgo para (country). La evaluación completa del riesgo del país está adjunta a este documento en el Anexo III.",
      disregardConfirmTitle: "Desestimar Cualquier Segmento o Todos",
      selectSegment: "Seleccionar segmentos para desestimar.",
      addConfirmTitle: "Agregar Cualquier Segmento o Todos",
      deselectToAddSegment: "Deselecciona los segmentos para agregar.",
      all: "Todos",
      protectedAreas: "Áreas Protegidas e Indígenas",
      verificaton: "Verificación con la Base de Datos del Gobierno de Brasil",
      confirmation: "Confirmación",
      confirmationMessage: "¿Está seguro de que desea desestimar la evaluación de riesgo regional? Confirmar esta acción resultará en la eliminación de la evaluación de riesgo regional del informe de debida diligencia.",
      noSegmentSelectedMessage: "No se ha seleccionado ningún segmento. Por favor, seleccione un segmento para continuar.",
      singleRiskAssessmentCriteriaMessage: "¿Está seguro de que desea agregar o eliminar los Criterios de Evaluación de Riesgo Regional? Confirmar esta acción actualizará el informe de debida diligencia.",
      singleProtectedAreasMessage: "¿Está seguro de que desea agregar o eliminar las Áreas Protegidas e Indígenas? Confirmar esta acción actualizará el informe de debida diligencia.",
      bothSegmentsMessage: "¿Está seguro de que desea agregar o eliminar tanto los Criterios de Evaluación de Riesgo Regional como las Áreas Protegidas e Indígenas? Confirmar esta acción actualizará el informe de debida diligencia.",
      segmentsUpdatedSuccessfully: "Segmentos actualizados con éxito",
      
    }  
};
